<template>
  <div class="page-wrapper thu-chi-nhapvao">
    <div class="content container-fluid">

      <!-- Tiêu đề + tab Chi tiêu / Thu nhập -->
      <div class="tc-header">
        <div class="tc-title">Sổ thu chi</div>

        <div class="tc-tabs">
          <button
            type="button"
            class="tc-tab"
            :class="{ active: loai === 'CHI' }"
            @click="changeLoai('CHI')"
          >
            Chi tiêu
          </button>
          <button
            type="button"
            class="tc-tab"
            :class="{ active: loai === 'THU' }"
            @click="changeLoai('THU')"
          >
            Tiền thu
          </button>
        </div>
      </div>

      <!-- Form nhập -->
      <div class="tc-form-card">

        <!-- Ngày -->
        <div class="tc-field">
          <label class="tc-label">Ngày</label>
          <div class="tc-input-row" @click="openDatePicker">
            <span>{{ ngayLabel }}</span>
            <i class="la la-calendar"></i>
          </div>
          <input
            ref="dateInput"
            type="date"
            class="d-none"
            v-model="ngay"
          />
        </div>

        <!-- Ghi chú -->
        <div class="tc-field">
          <label class="tc-label">Ghi chú</label>
          <input
            type="text"
            class="form-control tc-text-input"
            placeholder="Thêm ghi chú"
            v-model="ghiChu"
          />
        </div>

        <!-- Tiền -->
        <div class="tc-field">
          <label class="tc-label">
            {{ loai === 'CHI' ? 'Tiền chi' : 'Tiền thu' }}
          </label>
          <div class="tc-money-row">
            <input
              type="tel"
              class="form-control tc-money-input"
              :placeholder="loai === 'CHI' ? '0' : '0'"
              :value="soTienHienThi"
              @input="onMoneyInput"
            />
            <span class="tc-money-unit">đ</span>
          </div>
        </div>

        <!-- Danh mục -->
        <div class="tc-field">
          <label class="tc-label">Danh mục</label>
          <div class="tc-category-grid">
            <button
              v-for="dm in danhMucList"
              :key="dm.id"
              type="button"
              class="tc-category-item"
              :class="{ active: selectedDanhMucId === dm.id }"
              @click="selectedDanhMucId = dm.id"
            >
              <div class="tc-category-icon">
                <img
                  v-if="dm.iconUrl"
                  :src="dm.iconUrl"
                  alt="icon"
                  @error="onIconError($event)"
                />
                <span v-else>{{ dm.tenDanhMuc?.charAt(0) }}</span>
              </div>
              <div class="tc-category-name">
                {{ dm.tenDanhMuc }}
              </div>
            </button>

            <div
              v-if="danhMucList.length === 0"
              class="text-muted small tc-no-category"
            >
              Chưa có danh mục. Hãy nhờ quản lý tạo trong phần Quản trị.
            </div>
          </div>
        </div>

        <!-- Ảnh hoá đơn -->
        <div class="tc-field">
          <label class="tc-label d-flex justify-content-between align-items-center">
            <span>Ảnh hoá đơn</span>
            <div>
              <button
                type="button"
                class="btn btn-sm btn-outline-warning mr-1"
                @click="openCamera"
              >
                <i class="la la-camera mr-1"></i>
                Chụp hoá đơn
              </button>
            </div>
          </label>

          <div v-if="images.length" class="tc-images-list">
            <div
              v-for="img in images"
              :key="img.id"
              class="tc-image-item"
            >
              <img :src="img.previewUrl" alt="preview" />
              <button
                type="button"
                class="tc-image-remove"
                @click="removeImage(img.id)"
              >
                <i class="la la-times"></i>
              </button>
            </div>
          </div>
          <div v-else class="text-muted small">
            Có thể chụp nhiều tấm hoá đơn, sau đó xoá bớt nếu chụp nhầm.
          </div>
        </div>

        <!-- Nút submit -->
        <div class="tc-submit-wrap">
          <button
            type="button"
            class="btn tc-submit-btn"
            :disabled="submitting"
            @click="submitForm"
          >
            <span v-if="!submitting">
              Nhập khoản
              {{ loai === 'CHI' ? 'Tiền chi' : 'Tiền thu' }}
            </span>
            <span v-else>Đang lưu...</span>
          </button>
        </div>
      </div>

      <!-- Camera overlay -->
      <div v-if="cameraOpen" class="tc-camera-overlay">
        <div class="tc-camera-inner">
          <video
            ref="videoRef"
            autoplay
            playsinline
            class="tc-camera-video"
          ></video>

          <div class="tc-camera-actions">
            <button
              type="button"
              class="btn btn-outline-light mr-2"
              :disabled="switchingCamera || videoDevices.length <= 1"
              @click="switchCamera"
            >
              <i class="la la-refresh mr-1"></i>
              Đổi camera
            </button>

            <button
              type="button"
              class="btn btn-light mr-2"
              :disabled="takingPhoto"
              @click="takePhoto"
            >
              <i class="la la-camera mr-1"></i>
              Chụp
            </button>

            <button
              type="button"
              class="btn btn-outline-light"
              @click="closeCamera"
            >
              Đóng
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from "vue"
import api from "@/api/index.js"
import { useToast } from "vue-toastification"

const toast = useToast()

// ===== state chính =====
const loai = ref("CHI") // CHI | THU
const ngay = ref(new Date().toISOString().slice(0, 10))
const ghiChu = ref("")
const soTienHienThi = ref("")

const danhMucList = ref([])
const selectedDanhMucId = ref(null)

const images = ref([]) // {id, file, previewUrl}
const submitting = ref(false)

const dateInput = ref(null)

// camera
const cameraOpen = ref(false)
const videoRef = ref(null)
let mediaStream = null
const takingPhoto = ref(false)

// danh sách thiết bị video + index hiện tại để xoay trước/sau
const videoDevices = ref([]) // [{deviceId,label,...}]
const currentDeviceIndex = ref(0)
const switchingCamera = ref(false)

// ===== computed =====
const ngayLabel = computed(() => {
  if (!ngay.value) return ""
  const d = new Date(ngay.value + "T00:00:00")
  const thu = ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"][d.getDay()]
  const dd = String(d.getDate()).padStart(2, "0")
  const mm = String(d.getMonth() + 1).padStart(2, "0")
  const yyyy = d.getFullYear()
  return `${dd}/${mm}/${yyyy} (${thu})`
})

function parseSoTien() {
  if (!soTienHienThi.value) return 0
  const raw = soTienHienThi.value.replace(/[^0-9]/g, "")
  if (!raw) return 0
  return Number(raw)
}

// ===== load danh mục theo loại =====
async function loadDanhMuc() {
  try {
    danhMucList.value = []
    selectedDanhMucId.value = null
    const res = await api.get("/api/thu-chi/danh-muc", {
      params: { loai: loai.value } // backend: LoaiThuChi.CHI / THU
    })
    danhMucList.value = res.data || []
    if (danhMucList.value.length > 0) {
      selectedDanhMucId.value = danhMucList.value[0].id
    }
  } catch (e) {
    console.error(e)
    toast.error("Không tải được danh mục thu chi")
  }
}

function changeLoai(newLoai) {
  if (loai.value === newLoai) return
  loai.value = newLoai
  // reset form
  soTienHienThi.value = ""
  ghiChu.value = ""
  images.value.forEach(img => URL.revokeObjectURL(img.previewUrl))
  images.value = []
  loadDanhMuc()
}

// ===== date =====
function openDatePicker() {
  if (dateInput.value) {
    dateInput.value.showPicker
      ? dateInput.value.showPicker()
      : dateInput.value.click()
  }
}

// ===== tiền =====
function onMoneyInput(event) {
  const input = event.target.value || ""
  const digits = input.replace(/[^0-9]/g, "")
  if (!digits) {
    soTienHienThi.value = ""
    return
  }
  soTienHienThi.value = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

// ===== icon =====
function onIconError(e) {
  e.target.style.display = "none"
}

// ===== camera helpers =====
function stopStream() {
  if (mediaStream) {
    mediaStream.getTracks().forEach(t => t.stop())
    mediaStream = null
  }
}

async function setVideoStream(stream) {
  mediaStream = stream
  if (videoRef.value) {
    videoRef.value.srcObject = mediaStream
    await videoRef.value.play()
  }
}

// Lấy danh sách camera (sau khi đã có permission)
async function loadVideoDevicesFromBrowser(currentStream) {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    const videos = devices.filter(d => d.kind === "videoinput")
    videoDevices.value = videos

    if (!videos.length) {
      currentDeviceIndex.value = 0
      return
    }

    // đoán xem đang dùng device nào
    let idx = 0
    const track = currentStream?.getVideoTracks?.()[0]
    const settings = track?.getSettings ? track.getSettings() : {}
    const curId = settings.deviceId

    if (curId) {
      const found = videos.findIndex(d => d.deviceId === curId)
      if (found >= 0) idx = found
    } else {
      // ưu tiên camera sau nếu label chứa "back"/"environment"
      const backIdx = videos.findIndex(d =>
        /back|environment/i.test(d.label || "")
      )
      if (backIdx >= 0) idx = backIdx
    }

    currentDeviceIndex.value = idx
  } catch (e) {
    console.warn("enumerateDevices error", e)
  }
}

// Mở camera lần đầu (ưu tiên camera sau)
async function openCamera() {
  try {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      toast.error("Trình duyệt không hỗ trợ camera")
      return
    }

    cameraOpen.value = true
    await nextTick()

    // stream mặc định (ưu tiên environment)
    const defaultStream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: { ideal: "environment" } },
      audio: false
    })

    await setVideoStream(defaultStream)
    await loadVideoDevicesFromBrowser(defaultStream)
  } catch (e) {
    console.error(e)
    toast.error("Không truy cập được camera. Vui lòng kiểm tra quyền.")
    cameraOpen.value = false
    stopStream()
  }
}

// Đổi qua camera khác (trước / sau)
async function switchCamera() {
  if (videoDevices.value.length <= 1) return
  switchingCamera.value = true
  try {
    const nextIndex =
      (currentDeviceIndex.value + 1) % videoDevices.value.length
    const deviceId = videoDevices.value[nextIndex]?.deviceId

    stopStream()

    const constraints = deviceId
      ? { video: { deviceId: { exact: deviceId } }, audio: false }
      : { video: true, audio: false }

    const stream = await navigator.mediaDevices.getUserMedia(constraints)
    await setVideoStream(stream)
    currentDeviceIndex.value = nextIndex
  } catch (e) {
    console.error(e)
    toast.error("Không đổi được camera")
  } finally {
    switchingCamera.value = false
  }
}

function closeCamera() {
  stopStream()
  cameraOpen.value = false
}

// chụp ảnh từ camera hiện tại
async function takePhoto() {
  if (!videoRef.value) return
  takingPhoto.value = true
  try {
    const video = videoRef.value
    const w = video.videoWidth || 1280
    const h = video.videoHeight || 720

    const canvas = document.createElement("canvas")
    canvas.width = w
    canvas.height = h
    const ctx = canvas.getContext("2d")
    ctx.drawImage(video, 0, 0, w, h)

    const blob = await new Promise(resolve =>
      canvas.toBlob(b => resolve(b), "image/jpeg", 0.9)
    )
    if (!blob) return

    const file = new File([blob], `bill-${Date.now()}.jpg`, { type: "image/jpeg" })
    const previewUrl = URL.createObjectURL(blob)
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
    images.value.push({ id, file, previewUrl })
  } catch (e) {
    console.error(e)
    toast.error("Chụp ảnh thất bại")
  } finally {
    takingPhoto.value = false
  }
}

function removeImage(id) {
  const idx = images.value.findIndex(i => i.id === id)
  if (idx !== -1) {
    URL.revokeObjectURL(images.value[idx].previewUrl)
    images.value.splice(idx, 1)
  }
}

// ===== submit =====
async function submitForm() {
  if (!selectedDanhMucId.value) {
    toast.warning("Vui lòng chọn danh mục")
    return
  }
  const soTien = parseSoTien()
  if (!soTien || Number.isNaN(soTien)) {
    toast.warning("Vui lòng nhập số tiền hợp lệ")
    return
  }

  submitting.value = true
  try {
    // upload ảnh hoá đơn nếu có
    let imageUrls = []
    if (images.value.length) {
      const formData = new FormData()
      images.value.forEach(img => formData.append("files", img.file))
      formData.append("folderName", "thu-chi")

      const resUpload = await api.post("/api/images/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
      const arr = resUpload.data || []
      imageUrls = arr
        .map(x => x.location || x.url || x.filePath)
        .filter(Boolean)
    }

    // payload chuẩn ThuChiTaoRequest bên backend
    const payload = {
      loai: loai.value,                 // CHI / THU
      ngayGiaoDich: ngay.value,        // LocalDate
      soTien: soTien,                  // BigDecimal
      idDanhMuc: selectedDanhMucId.value,
      ghiChu: ghiChu.value || null,
      hinhThuc: "TIEN_MAT",            // enum HinhThucThanhToanThuChi
      dsAnhHoaDonUrl: imageUrls        // List<String>
    }

    await api.post("/api/thu-chi/my", payload)

    toast.success(
      "Đã lưu khoản " + (loai.value === "CHI" ? "chi tiêu" : "thu nhập")
    )

    // reset form
    soTienHienThi.value = ""
    ghiChu.value = ""
    images.value.forEach(img => URL.revokeObjectURL(img.previewUrl))
    images.value = []
  } catch (e) {
    console.error(e)
    toast.error("Lưu khoản thu chi thất bại")
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  loadDanhMuc()
})

onBeforeUnmount(() => {
  stopStream()
  images.value.forEach(img => URL.revokeObjectURL(img.previewUrl))
})
</script>

<style scoped>
.thu-chi-nhapvao {
  background: #fff7f0;
  min-height: calc(100vh - 70px);
  max-width: 480px;
  margin: 0 auto;
}

@media (min-width: 992px) {
  .thu-chi-nhapvao {
    max-width: 720px;
    border-radius: 12px;
  }
}

.tc-header {
  padding: 4px 2px;
}

.tc-title {
  font-weight: 600;
  font-size: 18px;
}

.tc-subtitle {
  font-size: 12px;
  color: #888;
  margin-bottom: 8px;
}

.tc-tabs {
  display: flex;
  border-bottom: 1px solid #f1c08a;
  margin-top: 4px;
}

.tc-tab {
  flex: 1;
  border: none;
  background: transparent;
  padding: 6px 0 8px;
  font-size: 14px;
  color: #999;
  border-bottom: 2px solid transparent;
}

.tc-tab.active {
  color: #ff8b00;
  border-color: #ff8b00;
  font-weight: 600;
}

/* Card form */
.tc-form-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px 12px 16px;
  margin-top: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}

.tc-field {
  margin-bottom: 12px;
}

.tc-label {
  font-size: 13px;
  margin-bottom: 4px;
  color: #666;
}

.tc-input-row {
  border-radius: 8px;
  background: #fff8ec;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #ffe1ba;
  font-size: 14px;
}

.tc-input-row i {
  color: #ff8b00;
}

/* ghi chú */
.tc-text-input {
  border-radius: 8px;
  background: #fff8ec;
  border-color: #ffe1ba;
}

/* tiền */
.tc-money-row {
  display: flex;
  align-items: center;
  border-radius: 8px;
  background: #fff8ec;
  border: 1px solid #ffe1ba;
  padding-right: 10px;
}

.tc-money-input {
  border: none;
  background: transparent;
  box-shadow: none;
}

.tc-money-input:focus {
  outline: none;
  box-shadow: none;
}

.tc-money-unit {
  font-weight: 600;
  color: #ff8b00;
}

/* danh mục */
.tc-category-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

@media (min-width: 768px) {
  .tc-category-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

.tc-category-item {
  border-radius: 8px;
  border: 1px solid #eee;
  background: #fff;
  padding: 6px 4px;
  text-align: center;
  font-size: 11px;
  color: #555;
  min-height: 70px;
}

.tc-category-item.active {
  border-color: #ff8b00;
  box-shadow: 0 0 0 1px rgba(255,139,0,0.2);
}

.tc-category-icon {
  width: 32px;
  height: 32px;
  margin: 0 auto 4px;
  border-radius: 8px;
  background: #fff8ec;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tc-category-icon img {
  max-width: 100%;
  max-height: 100%;
}

.tc-category-icon span {
  font-size: 16px;
  font-weight: 600;
  color: #ff8b00;
}

.tc-category-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tc-no-category {
  grid-column: 1 / -1;
}

/* ảnh */
.tc-images-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 8px;
  padding-bottom: 4px;
}

.tc-image-item {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex: 0 0 auto;
  border: 1px solid #eee;
}

.tc-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tc-image-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  border: none;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* nút submit */
.tc-submit-wrap {
  margin-top: 12px;
}

.tc-submit-btn {
  width: 100%;
  background: #ff8b00;
  color: #fff;
  font-weight: 600;
  border-radius: 999px;
  padding: 10px 0;
  border: none;
}

.tc-submit-btn:disabled {
  opacity: 0.7;
}

/* camera overlay */
.tc-camera-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0,0,0,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.tc-camera-inner {
  width: 100%;
  max-width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
}

.tc-camera-video {
  flex: 1;
  width: 100%;
  border-radius: 16px;
  background: #000;
  object-fit: cover;
}

.tc-camera-actions {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
}

.thu-chi-nhapvao {
  background: #fff7f0;
  min-height: calc(100vh - 70px);
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}

/* Tablet */
@media (min-width: 768px) {
  .thu-chi-nhapvao {
    max-width: 720px;
    border-radius: 16px;
  }

  .tc-form-card {
    padding: 20px;
  }

  .tc-category-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }

  .tc-category-item {
    min-height: 80px;
    padding: 8px 4px;
  }
}

/* Desktop */
@media (min-width: 1200px) {
  .thu-chi-nhapvao {
    max-width: 800px;
  }

  .tc-form-card {
    padding: 24px;
  }

  .tc-category-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
  }

  .tc-category-item {
    min-height: 90px;
    padding: 10px 6px;
  }

  .tc-category-item:hover {
    background-color: #fff8ec;
  }
}

/* Mobile nhỏ */
@media (max-width: 375px) {
  .tc-category-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
  }

  .tc-category-item {
    min-height: 70px;
    padding: 4px 2px;
  }
}
</style>
